import { Explicacao } from '../../../components/Explicacao'
import type { RegimeDaOs } from '../../../types/ordemDeServico'
import { TERMOS_DA_OS } from '../termosDaOs'
import { OS } from '../textosDaOs'

/** A chave do parâmetro que registra a indefinição. Aparece na tela para poder ser cobrada. */
const PARAMETRO = 'os.divisao_natureza'

/**
 * Por que a seção 6 do ANEXO IB não está nesta tela.
 *
 * **A ausência é dita, e não simplesmente ausente.** O modelo do contrato tem uma seção que reparte
 * o valor da ordem entre secretarias, e quem conhece o modelo vai procurá-la aqui. Não construí-la
 * e não explicar a falta faria o sistema parecer incompleto; explicar a falta mostra que a decisão
 * foi tomada e por quê.
 *
 * A palavra "divisão" ocorre **uma vez** em 233 páginas do TR (p.81). "Rateio", "órgão
 * participante", "carona" e "adesão" ocorrem zero. A dotação e o pagador são únicos (11.1 e 11.2,
 * p.75). Nem a planilha da fiscalização nem o termo de recebimento assinado a preencheram uma vez,
 * e o modelo tem quatro colunas para as quinze entidades atendidas em maio/2026. Modelar isso agora
 * petrificaria um desenho que o próprio contrato não sustenta — e exigiria o quarto cadastro de
 * órgão do município.
 *
 * O selo INDETERMINADO é o mesmo dos critérios do fechamento: ele diz que o contrato não decidiu, e
 * não que o sistema não fez.
 *
 * @param props o regime da ordem — a seção é do ANEXO IB
 * @returns a nota, ou nada no regime de projeto
 */
export function NotaDaDivisao({ regime }: { regime: RegimeDaOs }) {
  if (regime !== 'SUSTENTACAO_INFRAESTRUTURA') {
    return null
  }

  return (
    <section aria-label={OS.divisao.titulo} className="rounded-xl border border-slate-200 bg-slate-50 p-4">
      <h3 className="flex items-center gap-1.5 text-sm font-semibold text-slate-900">
        {OS.divisao.titulo}
        <Explicacao titulo={TERMOS_DA_OS.divisaoDaOs.rotulo} texto={TERMOS_DA_OS.divisaoDaOs.ajuda} />
        <span className="rounded bg-slate-200 px-1.5 py-0.5 text-xs font-medium text-slate-800">INDETERMINADO</span>
      </h3>
      <p className="mt-1 max-w-prose text-sm text-slate-700">{OS.divisao.ajuda}</p>
      <p className="mt-1 text-xs text-slate-500">
        Critério {PARAMETRO} · ANEXO IB, item 6, p.81 — a única ocorrência da palavra no contrato.
      </p>
    </section>
  )
}
